import { Form, Input, Modal } from 'antd';
import { useState, useEffect } from 'react';

interface SaveAsModalProps {
    open: boolean,
    onOk: (value?: string) => void,
    onCancel: () => void
}

function SaveAsModal({ open, onOk, onCancel } : SaveAsModalProps) {
  const [form] = Form.useForm();
  const [isValid, setIsValid] = useState(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onOk(values.styleName);
    } catch (error) {
      // Validation failed
    }
  };

  const handleValuesChange = async () => {
    try {
      await form.validateFields();
      const styleName = form.getFieldValue('styleName');
      setIsValid(!!styleName);
    } catch (e) {
      const error = e as { errorFields: unknown[] };
      if (error.errorFields.length === 0) {
        setIsValid(true);
      } else {
        setIsValid(false);
      }
    }
  };

  useEffect(() => {
    if (!open) {
      form.resetFields();
      setIsValid(false);
    }
  }, [open, form]);

  return (
    <Modal
      open={open}
      title="Save as..."
      onCancel={onCancel}
      destroyOnClose
      onOk={handleOk}
      okButtonProps={{
        disabled: !isValid,
      }}
    >
      <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
        <Form.Item
          name="styleName"
          rules={[
            { required: true, message: 'Please enter a style name' },
            {
              pattern: /^(?!\d+$)[A-Za-z0-9_-]+$/,
              message: 'Style name must contain letters, numbers, underscores or hyphens, and cannot be only numbers',
            },
          ]}
        >
          <Input placeholder="Enter style name" />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SaveAsModal;
